import RSAKey from '@/assets/js/rsa/rsa';
import instance from '@/composables/axios';
import instanceNew from '@/composables/axiosNew';
import { Decode } from '@/composables/utils';
import HRService from '@/service/employee/HRService';
import VueJwtDecode from 'vue-jwt-decode';
import store from '@/store';

const URL = process.env.VUE_APP_URL_EMPLOYEE_SERVICE + 'account';

export default {
  async login(email, password, callbacks) {
    const rsa = new RSAKey();
    const publicKey = await instance(URL).get('rsa/get');
    rsa.setPublic(publicKey.modulus, publicKey.exponent);

    const emailEncrypted = await rsa.encrypt(email);
    const passwordEncrypted = await rsa.encrypt(password);
    const dto = { email: emailEncrypted, password: passwordEncrypted };
    const response = await instanceNew(URL, callbacks).post('login', dto);
    return response;
  },

  async checkDuplicate(email) {
    const response = await instance(URL).get('check/duplicate/' + email);
    if (response) {
      alert('사용가능한 이메일입니다.');
    }
  },

  async registerOtp(email, password) {
    const rsa = new RSAKey();
    const publicKey = await instance(URL).get('rsa/get');
    rsa.setPublic(publicKey.modulus, publicKey.exponent);

    const emailEncrypted = await rsa.encrypt(email);
    const passwordEncrypted = await rsa.encrypt(password);
    const response = await instance(URL).post('otp/register', {
      email: emailEncrypted,
      password: passwordEncrypted,
    });
    return response;
  },

  async authOtp(authNum, callbacks) {
    const response = await instanceNew(URL, callbacks).post('otp/auth', {
      authNum,
    });
    return response;
  },

  async resetOtp(id, callbacks) {
    const response = await instanceNew(URL, callbacks).get(`otp/reset/${id}`);
    return response;
  },

  async validateToken(callbacks) {
    const response = await instanceNew(URL, callbacks).get('token');
    return response;
  },

  async employee(id) {
    const employeeId = id || Decode.getDecode().employeeId;
    const response = await HRService.getOne(employeeId);
    if (response) {
      return {
        id: employeeId,
        email: response.email,
        img: response.photoPath,
        name: response.nameKr,
        team: response.team.name,
        position: response.rank.name,
      };
    }
  },

  async setProfile() {
    const token = store.getters['authority/token'];
    if (!token) return;

    const decode = VueJwtDecode.decode(token);
    const response = await HRService.getOne(decode.employeeId);
    if (response) {
      const profile = {
        img: response.photoPath,
        name: response.nameKr,
        team: response.team.name,
        position: response.rank.name,
        dept: response.team.dept.name,
      };
      store.dispatch('profile/set', profile);
    }
  },

  employeeID() {
    return Decode.getDecode().employeeId;
  },
};
